import { useQueryClient } from "@tanstack/react-query"
import { useAppStateActions } from "@/modules/auth/store/useAppStateStore"
import { useServicesContext } from "@/modules/core/services/services.context"
import { UserProfileEntity } from "@/modules/users/entities/usersEntity"
import { usersKeys } from "@/modules/users/gateway/usersKeys"

/**
 * use useFetchUser to fetch user the first time after login
 */
export const useFetchUser = () => {
  const queryClient = useQueryClient()
  const { userProfileApi } = useServicesContext()
  const { setAppStateUser } = useAppStateActions()
  return () =>
    queryClient.fetchQuery({
      queryKey: usersKeys.me(),
      queryFn: async () => {
        const result = await userProfileApi.getUser()
        const user = UserProfileEntity.fromDto(result)
        setAppStateUser({ user })
        return user
      },
    })
}
